import {css} from "lit";
import {commonStyles} from "../styles/Common.js";
import {iconStyles} from "../styles/Icons.js";

export const toastStyles = [commonStyles, iconStyles, css`
	:host {
		position: absolute;
		left: 0;
		top: 0;
		z-index: 21474836278; /* higher than the sidebar */
	}

	.container {
		position: fixed;

		/* Place at bottom right corner */
		right: 20px;
		bottom: 15px;

		padding: 15px;
		opacity: 0;
		transition: all 0.3s ease-out;

		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 6px;
		user-select: none;
	}

	.container.open {
		opacity: 1;
	}

	.container.fit-width {
		width: fit-content;
	}

	.container.fit-width #pn-logo {
		margin-right: 12px;
	}

	.container.full-widith .content {
		margin: 0 25px;
	}

	#pn-logo {
		width: 24px;
	}

	.content {
		color: var(--pn-toast-text-color);
		font-weight: 500;
		font-size: 14px;
		text-align: center;
		line-height: 20px;
	}

	.content a {
		color: inherit;
		text-decoration: underline;
	}
	
	button {
		font-size: inherit;
	}

	.error {
		background-color: var(--pn-toast-error-bg-color);
	}

	.info {
		background-color: var(--pn-toast-info-bg-color);
	}

	.share {
		background-color: var(--pn-toast-share-bg-color);
	}

	.success {
		background-color: var(--pn-toast-success-bg-color);
	}

	.warning {
		background-color: var(--pn-toast-warning-bg-color);
	}
`];
